import * as React from 'react';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import { Button, Typography, Link, Box, InputBase } from '@mui/material';
import { styled } from '@mui/system';
import colors from '../../vars.module.scss';

const Container = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: '#fff',
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[1],
}));

const Title = styled(Typography)(({ theme }) => ({
  color: colors.primaryColor,
  marginBottom: theme.spacing(1),
  fontWeight: theme.typography.fontWeightBold,
}));

const ClearAction = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  marginTop: theme.spacing(1),
}));

const StyledLink = styled(Link)(({ theme }) => ({
  color: colors.primaryColor,
  '&:hover': {
    cursor: 'pointer',
    textDecoration: 'underline',
  },
}));

export default function TextArea({ title = null, clearText, placeholder, onChange, value, onCancel }) {
  return (
    <Container>
      {title && (
        <Title component="div" variant="h6">
          {title}
        </Title>
      )}
      <InputBase
        inputComponent={TextareaAutosize}
        inputProps={{
          minRows: 18,
          maxRows: 18,
        }}
        sx={{
          width: '100%',
          fontSize: '16px',
          padding: '12px',
          borderRadius: '4px',
          border: '1px solid #ccc',
          boxSizing: 'border-box',
          outline: 'none',
          resize: 'none',
        }}
        placeholder={placeholder}
        aria-label="maximum height"
        onChange={onChange}
        value={value}
      />
      <ClearAction>
        <StyledLink
          component={Button}
          disabled={value === ''}
          onClick={onCancel}
          sx={{
            textTransform: 'none',
            fontWeight: 'bold',
            padding: 0,
            minWidth: 0,
          }}
        >
          {clearText}
        </StyledLink>
      </ClearAction>
    </Container>
  );
}
